global.$ = global.jQuery = require('jquery');
// require('jquery')

if (parent.frames.length) {
    var addListenerMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    var messageEvent = addListenerMethod == "attachEvent" ? "onmessage" : "message";

    var headerOffset = $('#normalheader').offset().top;
    var thisSiteHeight = $('body').height() + 0;

    var eventOrigin, eventSource, targetId, resizeTimeout;

    var iterator = 0;
    window[addListenerMethod](messageEvent, function (event) {
        eventOrigin = event.origin;
        eventSource = event.source;

        if (!event.data || !event.data.length) {
            return;
        }

        var eventData = event.data.match(/^height-(\d+)$/);
        if (eventData != null) {
            targetId = parseInt(eventData[1], 10);

            eventSource.postMessage(targetId + '-' + thisSiteHeight + '-' + 0, eventOrigin);
        }
        else {
            try {
                eventData = JSON.parse(event.data);
                var newScrollY = eventData.params.scrollY;
                var offsetY = eventData.params.offsetY;
                var difference = newScrollY - (offsetY + headerOffset);

                if (difference >= 0) {
                    $('#normalheader').css('transform', 'translateY(' + difference + 'px)');
                }
                else {
                    $('#normalheader').css('transform', '');
                }
            }
            catch (error) {
                console.error('Event data invalid', error);
            }
        }

    }, false);

    var messageInterval, intervalTimeout;

    function moveStickyNav() {
        clearInterval(messageInterval);
        clearTimeout(intervalTimeout);

        messageInterval = setInterval(function () {
            window.parent.postMessage({
                type: 'getDimensions'
            }, '*');
        }, 5);

        intervalTimeout = setTimeout(function () {
            clearInterval(messageInterval);
        }, 500);
    }

    function propagateResizeing(offsetPosition) {
        if (window.self != window.top) {
            var thisSiteHeight = $('body').height() + 0;

            if (offsetPosition !== undefined) {
                eventSource.postMessage(targetId + '-' + thisSiteHeight + '-' + offsetPosition, eventOrigin);
            } else {
                eventSource.postMessage(targetId + '-' + thisSiteHeight, eventOrigin);
            }
        }
    }

    var iterator = 0;
    setInterval(function () {
        moveStickyNav();
    }, 100);

    $(window).resize(function () {
        $('#normalheader').css('transform', '');
        headerOffset = $('#normalheader').offset().top;

        clearTimeout(resizeTimeout)
        resizeTimeout = setTimeout(function () {
            propagateResizeing();
        }, 100);
    });

    $(document).ready(function () {
        headerOffset = $('#normalheader').offset().top;
    });

    $('.anker-link').each(function () {
        $(this).click(function (event) {
            event.preventDefault();

            var target = $($(this).attr('href'));
            var targetOffset = target.offset().top - 115;

            window.parent.postMessage({
                type: 'scroll',
                params: {
                    scrollTo: targetOffset
                }
            }, '*');
            moveStickyNav();
        })
    })
}